import { SvgIcon } from '@mui/material';
import type { SvgIconProps } from '@mui/material/SvgIcon';

import type { IconType } from '../../types';

const IconName = 'Briefcase';

const IconSvg = `
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.75 4.5C9.33579 4.5 9 4.83579 9 5.25V7.5H15V5.25C15 4.83579 14.6642 4.5 14.25 4.5H9.75ZM16.5 7.5V5.25C16.5 4.00736 15.4926 3 14.25 3H9.75C8.50736 3 7.5 4.00736 7.5 5.25V7.5H5.25C4.00736 7.5 3 8.50736 3 9.75V18.75C3 19.9926 4.00736 21 5.25 21H18.75C19.9926 21 21 19.9926 21 18.75V9.75C21 8.50736 19.9926 7.5 18.75 7.5H16.5ZM5.25 9C4.83579 9 4.5 9.33579 4.5 9.75V12H19.5V9.75C19.5 9.33579 19.1642 9 18.75 9H5.25ZM19.5 13.5H14.7135L14.1708 14.5854C14.0438 14.8395 13.7841 15 13.5 15H10.5C10.2159 15 9.95622 14.8395 9.82918 14.5854L9.28647 13.5H4.5V18.75C4.5 19.1642 4.83579 19.5 5.25 19.5H18.75C19.1642 19.5 19.5 19.1642 19.5 18.75V13.5Z" fill="currentColor"/>
  </svg>
`;

const BriefcaseIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.75 4.5C9.33579 4.5 9 4.83579 9 5.25V7.5H15V5.25C15 4.83579 14.6642 4.5 14.25 4.5H9.75ZM16.5 7.5V5.25C16.5 4.00736 15.4926 3 14.25 3H9.75C8.50736 3 7.5 4.00736 7.5 5.25V7.5H5.25C4.00736 7.5 3 8.50736 3 9.75V18.75C3 19.9926 4.00736 21 5.25 21H18.75C19.9926 21 21 19.9926 21 18.75V9.75C21 8.50736 19.9926 7.5 18.75 7.5H16.5ZM5.25 9C4.83579 9 4.5 9.33579 4.5 9.75V12H19.5V9.75C19.5 9.33579 19.1642 9 18.75 9H5.25ZM19.5 13.5H14.7135L14.1708 14.5854C14.0438 14.8395 13.7841 15 13.5 15H10.5C10.2159 15 9.95622 14.8395 9.82918 14.5854L9.28647 13.5H4.5V18.75C4.5 19.1642 4.83579 19.5 5.25 19.5H18.75C19.1642 19.5 19.5 19.1642 19.5 18.75V13.5Z'
      fill='currentColor'
    />
  </SvgIcon>
);

export default {
  name: IconName,
  title: IconName,

  IconComponent: BriefcaseIcon,
  IconSvg: IconSvg
} as IconType;
